<script lang="ts" setup>
const explanationModalIsOpen = ref(false)

definePageMeta({
  layout: 'ausserbetriebsetzung-flow',
})

useSeoMeta({
  title: 'Vorbereitung'
})

useHead({
  meta: [
    { name: 'robots', content: 'noindex' }
  ]
})

const preparationSteps = [
  {
    heading: '1. Zulassungs&shy;bescheinigung Teil 1 bereitlegen',
    description: 'FIN & Sicherheitscode werden gebraucht'
  }, {
    heading: '2. Kfz-Kennzeichen vom Fahrzeug abnehmen',
    description: 'Kennzeichen Vorn und Hinten. (Ausnahme, wenn nur ein Kennzeichen verfügbar z.B. Motorrad, Anhänger)'
  }
]
</script>

<template lang="pug">
LayoutFlowStep.vorbereitung
  template(#top)
    h1.text-4xl.text-center.font-bold.mb-12 Vorbereitung

  template(#input)
    CheckCard(
      v-for="prepStep in preparationSteps"
      :key="prepStep.heading"
      :heading="prepStep.heading"
      :description="prepStep.description"
      selected
    ).mt-4

    p.text-blue-600.cursor-pointer.text-center(
      @click="explanationModalIsOpen = true"
    ).my-12
      u So überprüfen Sie, ob Ihr Fahrzeug für die digitale Außerbetriebsetzung geeignet ist

  template(#actions)
    nuxt-link(to="/ausserbetriebsetzung/daten/generell")
      UButton Weiter

UModal(v-model="explanationModalIsOpen")
  UCard
    template(#header)
      h3.font-bold.text-lg Ist ihr Fahrzeug geeignet?

    p.mb-2.
      Wenn Sie ein Fahrzeug haben, das seit dem 01.01.2015 neu zugelassen oder wieder zugelassen wurde,
      dann können Sie dieses bequem von zu Hause über ein Online‐Verfahren abmelden.

    p.mb-2.
      Kontrollieren Sie Ihre Zulassungsbescheinigung Teil 1. Wenn dort auf der Rückseite ein Sicherheitscode
      freigelegt werden kann, ist Ihr Fahrzeug für die digitale Außerbetriebsetzung geeignet.


    
</template>

<style lang="sass">
.vorbereitung
  .check-card .icon
    @apply hidden

</style>
